import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import Link from '@ux/link';
import { golf } from './enums';

export function Pro({ loggedIn, proshopper, eids, urlArgs, urls }) {
  if (!loggedIn || !proshopper) {
    return null;
  }

  return (
    <Link
      className='customer-link'
      urlArgs={ urlArgs }
      { ...urls.proHomeApp }
      data-eid={ eids.pro }>
      <FormattedMessage tagName='span' id={ golf.pro } />
    </Link>
  );
}

Pro.propTypes = {
  eids: PropTypes.object,
  loggedIn: PropTypes.bool,
  proshopper: PropTypes.bool,
  urlArgs: PropTypes.any,
  urls: PropTypes.object
};

export default Pro;
